// extracted by mini-css-extract-plugin
module.exports = {"container":"StopGoBrandsActionsCell_container__8eAOf","actionIcon":"StopGoBrandsActionsCell_actionIcon__enzUz"};